// hero slider 
$(document).ready(function(){
    hero_slider();
    product_slider();
    upsell_slider();
    collection_item_slider();
    review_slider();
    instagram();

    // product tab 
    $('.product-tab-item').on('click', function(){
        var id = $(this).data('id');
        $(this).addClass('active').siblings().removeClass('active');
        $('#tab_'+id).addClass('show').siblings().removeClass('show');
        $('.product-contents-slider').slick('setPosition');
        product_slider();
    })

    // size guide 
    $('span.size-quide-btn').on('click', function(){
        $('.size-quide').fadeIn();
    })

    $('.size-guide-close, .size-guide-overly').on('click', function(){
        $('.size-quide').fadeOut();
    })

    // cart dreawer 
    $('.header_cart').on('click', function(e){
        e.preventDefault();
        $('body').addClass('cartshown');
    })
    $('.cart-drawer-close, .cart-drawer-overly').on('click', function(){
        $('body').removeClass('cartshown');
    })
})

document.addEventListener("shopify:section:load", function() {
    hero_slider(); 
})

document.addEventListener("shopify:section:load", function() {
    product_slider(); 
    upsell_slider(); 
    collection_item_slider(); 
    
})

function hero_slider() {
    $('.slider-items').slick({ 
        speed:300,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows:true,
        dots:true,
        prevArrow:"<span type='button' class='arrow-prev'><img src='"+ arrow +"' alt='arrow'></span>",
        nextArrow:"<span type='button' class='arrow-next'><img src='"+ arrow +"' alt='arrow'></span>"
    }); 
}
// upsell slider 
function upsell_slider() {
    $('.drawer-upsell-items').slick({ 
        speed:300,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        arrows:true,
        dots:false,
        prevArrow:"<span type='button' class='arrow-prev'><img src='"+ arrow +"' alt='arrow'></span>",
        nextArrow:"<span type='button' class='arrow-next'><img src='"+ arrow +"' alt='arrow'></span>"
    }); 
}
// upsell slider 
function collection_item_slider() {
    $('.collection-item-slider').slick({ 
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow:"<span type='button' class='product-arrow-prev'><img src='"+ arrow +"' alt='arrow'></span>",
        nextArrow:"<span type='button' class='product-arrow-next'><img src='"+ arrow +"' alt='arrow'></span>",
        dots:false,
        responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
              }
            }
        ]
    }); 
}

// product tab with slider 
function product_slider() {
    $('.product-contents-slider').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow:"<span type='button' class='product-arrow-prev'><img src='"+ arrow +"' alt='arrow'></span>",
        nextArrow:"<span type='button' class='product-arrow-next'><img src='"+ arrow +"' alt='arrow'></span>",
        dots:false,
        responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
              }
            }
          ]
    })
    // .on('setPosition', function (event, slick) {
    //     slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    // });
}

// product tab in single page 
var el = document.querySelectorAll('ul.info-tab-items li');
var contents = document.querySelectorAll('.product-info-tab-contents .info-tab-content');
for (let i = 0; i < el.length; i++) {
  el[i].onclick = function() {
    var c = 0;
    while (c < el.length) {
      el[c++].className = 'info-tab-item';
    }
    el[i].className = 'info-tab-item active';
    var id = this.getAttribute('data-id');
    var d = 0;
    while (d < contents.length) {
        contents[d++].className = 'info-tab-content';
        if(id == d) {
            contents[i].className = 'info-tab-content show';
        }
    }
  };
}

document.addEventListener("shopify:section:load", function() {
    review_slider(); 
    instagram(); 
})

if($(window).innerWidth() < 600) {
  $('.three-column').slick({
    dots: true,
    arrows:false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:"<span type='button' class='product-arrow-prev'><img src='"+ arrow +"' alt='arrow'></span>",
    nextArrow:"<span type='button' class='product-arrow-next'><img src='"+ arrow +"' alt='arrow'></span>"
  });
}


function review_slider() {
    $('.reviews-items').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow:"<span type='button' class='product-arrow-prev'><img src='"+ arrow +"' alt='arrow'></span>",
        nextArrow:"<span type='button' class='product-arrow-next'><img src='"+ arrow +"' alt='arrow'></span>",
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows:false
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows:false
            }
          }
        ]
    });
}

function instagram() {
    $('.instagram-items').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows:true,
        prevArrow:"<span type='button' class='arrow-prev'>"+ arrow +"</span>",
        nextArrow:"<span type='button' class='arrow-next'>"+ arrow +"</span>",
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows:false
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows:false
            }
          }
        ]
    });
}


function cart_item_update() {
  fetch('/?section_id=cart-drawer')
      .then(reponse => reponse.text())
      .then(cartData => {
          var cart_html = $(cartData);
          var cart_progress = $('.cart-progress-wrap', cart_html);
          var cart_items = $('.cart-drawer-items', cart_html);
          var cart_footer = $('.cart-drawer-footer', cart_html);
          
          $('.cart-progress-wrap').replaceWith(cart_progress);
          $('.cart-drawer-items').replaceWith(cart_items);
          $('.cart-drawer-footer').replaceWith(cart_footer);
          
  });

  $.getJSON('/cart.js', function(cart){
      var total_items = cart.item_count;
      $('.cart-count-bubble span').text(total_items);
      if(total_items == 0) {
        $('.main-cartdrawer').addClass('empty_cart');
      }else{
        $('.main-cartdrawer').removeClass('empty_cart');
      }
  }) 
}